import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_17181562 from 'nuxt_plugin_plugin_17181562' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0409066c from 'nuxt_plugin_plugin_0409066c' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_viewportserver_341964fa from 'nuxt_plugin_viewportserver_341964fa' // Source: ./viewport.server.js (mode: 'server')
import nuxt_plugin_viewportclient_ff8c480a from 'nuxt_plugin_viewportclient_ff8c480a' // Source: ./viewport.client.js (mode: 'client')
import nuxt_plugin_dayjsplugin_743a8336 from 'nuxt_plugin_dayjsplugin_743a8336' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_distplugin57527824_268e2af4 from 'nuxt_plugin_distplugin57527824_268e2af4' // Source: ./dist.plugin.57527824.mjs (mode: 'all')
import nuxt_plugin_router_eb619192 from 'nuxt_plugin_router_eb619192' // Source: ./router.js (mode: 'all')
import nuxt_plugin_workbox_6c233a94 from 'nuxt_plugin_workbox_6c233a94' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_deviceplugin_70ee6303 from 'nuxt_plugin_deviceplugin_70ee6303' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_imageFormat_2c501bfc from 'nuxt_plugin_imageFormat_2c501bfc' // Source: ../src/plugins/imageFormat (mode: 'all')
import nuxt_plugin_nuxtlink_33ad5dce from 'nuxt_plugin_nuxtlink_33ad5dce' // Source: ../src/plugins/nuxt-link (mode: 'all')
import nuxt_plugin_svgicon_79745ca7 from 'nuxt_plugin_svgicon_79745ca7' // Source: ../src/plugins/svgicon (mode: 'all')
import nuxt_plugin_user_6a875c41 from 'nuxt_plugin_user_6a875c41' // Source: ../src/plugins/user (mode: 'server')
import nuxt_plugin_mask_6a837762 from 'nuxt_plugin_mask_6a837762' // Source: ../src/plugins/mask (mode: 'all')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e' // Source: ../src/plugins/polyfills (mode: 'client')
import nuxt_plugin_teleport_bbf786be from 'nuxt_plugin_teleport_bbf786be' // Source: ../src/plugins/teleport (mode: 'client')
import nuxt_plugin_adfox_3578efd4 from 'nuxt_plugin_adfox_3578efd4' // Source: ../src/plugins/adfox (mode: 'client')
import nuxt_plugin_amberData_68fad712 from 'nuxt_plugin_amberData_68fad712' // Source: ../src/plugins/amberData (mode: 'client')
import nuxt_plugin_yandexMetrika_760ec67c from 'nuxt_plugin_yandexMetrika_760ec67c' // Source: ../src/plugins/yandexMetrika (mode: 'client')
import nuxt_plugin_liveInternet_1c426a7a from 'nuxt_plugin_liveInternet_1c426a7a' // Source: ../src/plugins/liveInternet (mode: 'client')
import nuxt_plugin_mailRu_5102ad60 from 'nuxt_plugin_mailRu_5102ad60' // Source: ../src/plugins/mailRu (mode: 'client')
import nuxt_plugin_vueTouchEvents_4d54a4c8 from 'nuxt_plugin_vueTouchEvents_4d54a4c8' // Source: ../src/plugins/vueTouchEvents (mode: 'client')
import nuxt_plugin_mourningMode_0a1118a8 from 'nuxt_plugin_mourningMode_0a1118a8' // Source: ../src/plugins/mourningMode (mode: 'client')
import nuxt_plugin_meta_1d50025c from 'nuxt_plugin_meta_1d50025c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"title":"Forbes.ru | Бизнес, миллиардеры, новости, финансы, инвестиции, компании","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"format-detection","name":"format-detection","content":"telephone=no"},{"name":"robots","content":"max-image-preview:large, max-snippet:-1, max-video-preview:-1"},{"hid":"description","name":"description","content":"Материалы на сайте Forbes.ru | Бизнес, миллиардеры, новости, финансы, инвестиции, компании."},{"hid":"og:locale","property":"og:locale","content":"ru_RU"},{"hid":"og:site_name","property":"og:site_name","content":"Forbes.ru"},{"hid":"og:type","property":"og:type","content":"website"},{"name":"telegram:channel","content":"@forbesrussia"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:creator","content":"@ForbesRussia"},{"name":"twitter:site","content":"@forbesrussia"},{"property":"fb:app_id","content":"1700610573541605"},{"hid":"og:description","property":"og:description","content":"Материалы на сайте Forbes.ru | Бизнес, миллиардеры, новости, финансы, инвестиции, компании."},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.forbes.ru\u002Fshare-placeholder.png"},{"hid":"og:title","property":"og:title","content":"Forbes.ru | Бизнес, миллиардеры, новости, финансы, инвестиции, компании"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fwww.forbes.ru"},{"name":"msapplication-TileColor","content":"#101010"},{"name":"msapplication-config","content":"\u002Ffavicon\u002Fbrowserconfig.xml?v=2"},{"name":"theme-color","content":"#101010"},{"name":"zen-verification","content":"qeSVUY4LFBj8mU1JOYXBYLip9JfrFcY3xeU2TB5uMOIBFf4PRfr61IHD0lYEP27k"}],"link":[{"hid":"canonical","rel":"canonical","href":"https:\u002F\u002Fwww.forbes.ru"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png?v=2"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png?v=2"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest?v=2"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg?v=2","color":"#101010"},{"rel":"shortcut icon","href":"\u002Ffavicon\u002Ffavicon.ico?v=2"},{"href":"\u002F\u002Fcdn.forbes.ru","rel":"preconnect","crossorigin":""},{"href":"\u002F\u002Fcdn.forbes.ru","rel":"dns-prefetch"},{"href":"\u002F\u002Fwww.googletagmanager.com","rel":"dns-prefetch"},{"href":"\u002F\u002Fmc.yandex.ru","rel":"dns-prefetch"},{"href":"\u002F\u002Fyandex.ru","rel":"dns-prefetch"}],"noscript":[{"innerHTML":"К сожалению, сайт не работает без включенного JavaScript. Пожалуйста, включите JavaScript в настройках вашего браузера."}],"script":[],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_17181562 === 'function') {
    await nuxt_plugin_plugin_17181562(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0409066c === 'function') {
    await nuxt_plugin_plugin_0409066c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_viewportserver_341964fa === 'function') {
    await nuxt_plugin_viewportserver_341964fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_viewportclient_ff8c480a === 'function') {
    await nuxt_plugin_viewportclient_ff8c480a(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_743a8336 === 'function') {
    await nuxt_plugin_dayjsplugin_743a8336(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin57527824_268e2af4 === 'function') {
    await nuxt_plugin_distplugin57527824_268e2af4(app.context, inject)
  }

  if (typeof nuxt_plugin_router_eb619192 === 'function') {
    await nuxt_plugin_router_eb619192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6c233a94 === 'function') {
    await nuxt_plugin_workbox_6c233a94(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_70ee6303 === 'function') {
    await nuxt_plugin_deviceplugin_70ee6303(app.context, inject)
  }

  if (typeof nuxt_plugin_imageFormat_2c501bfc === 'function') {
    await nuxt_plugin_imageFormat_2c501bfc(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtlink_33ad5dce === 'function') {
    await nuxt_plugin_nuxtlink_33ad5dce(app.context, inject)
  }

  if (typeof nuxt_plugin_svgicon_79745ca7 === 'function') {
    await nuxt_plugin_svgicon_79745ca7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_user_6a875c41 === 'function') {
    await nuxt_plugin_user_6a875c41(app.context, inject)
  }

  if (typeof nuxt_plugin_mask_6a837762 === 'function') {
    await nuxt_plugin_mask_6a837762(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_7dce8c4e === 'function') {
    await nuxt_plugin_polyfills_7dce8c4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_teleport_bbf786be === 'function') {
    await nuxt_plugin_teleport_bbf786be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_adfox_3578efd4 === 'function') {
    await nuxt_plugin_adfox_3578efd4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amberData_68fad712 === 'function') {
    await nuxt_plugin_amberData_68fad712(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexMetrika_760ec67c === 'function') {
    await nuxt_plugin_yandexMetrika_760ec67c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liveInternet_1c426a7a === 'function') {
    await nuxt_plugin_liveInternet_1c426a7a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mailRu_5102ad60 === 'function') {
    await nuxt_plugin_mailRu_5102ad60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueTouchEvents_4d54a4c8 === 'function') {
    await nuxt_plugin_vueTouchEvents_4d54a4c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mourningMode_0a1118a8 === 'function') {
    await nuxt_plugin_mourningMode_0a1118a8(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_1d50025c === 'function') {
    await nuxt_plugin_meta_1d50025c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
